import { createFileRoute } from "@tanstack/react-router";

import { CatalogRoute } from "../screens/catalog-route";

export const Route = createFileRoute("/locations")({
  component: () => <CatalogRoute path="/locations" kind="Location" />,
});
